import { getInfoOfDeviceOS } from '../../assets/js/common-es6';
import { getGaUserId } from './firebaseAnalytics';

const getBridge = () => {
  const deviceOS = getInfoOfDeviceOS();

  const wn: any = window;
  if (!wn.__TROST_APP__) wn.__TROST_APP__ = {};

  let bridge = {};

  if (deviceOS === 'ios') {
    bridge = wn?.webkit?.messageHandlers;
  }

  if (deviceOS === 'android') {
    bridge = wn?.__TROST_APP__;
  }

  return {
    bridge,
    deviceOS,
  };
};

const bridgeFunc = (name:string, ...args:any[]) => {
  try {
    const { bridge, deviceOS } = getBridge();

    if (deviceOS === 'ios') {
      return bridge?.[name]?.postMessage(...args);
    }

    if (bridge && bridge[name]) {
      !args.length ? bridge[name]() : bridge[name](...args);
    }
  } catch (e) {
    console.log(e, 'bridge error');
  }
};

export const trostBridgeConfig = {
  firebaseEvent: ({ eventName, params }:{eventName: string, params?: Record<string, any>}) => {
    const deviceOS = getInfoOfDeviceOS();

    if (process.env.NODE_ENV === 'development') {
      return console.log('bridgeFunc', params);
    }

    // 웹뷰는 GA config를 거치지 않고 native SDK가 발사하므로 user_id를 params에 직접 싣는다.
    const gaUserId = getGaUserId();
    const payload = gaUserId ? { ...(params || {}), user_id: gaUserId } : params;

    if (deviceOS === 'ios') {
      return bridgeFunc('fireBaseEvent', {
        fireBasePayload: JSON.stringify({
          name: eventName,
          payload,
        }),
      });
    }

    if (deviceOS === 'android') {
      bridgeFunc('fireBaseEvent', eventName, JSON.stringify(payload));
    }
  },
};
